export function drawTimeCanvas(
    timeCanvas: HTMLCanvasElement | null,
    timeData: Uint8Array,
    bufferLength: number
) {
    if (timeCanvas) {
        const ctx = timeCanvas.getContext('2d');
        if (ctx) {
            const width = timeCanvas.width;
            const height = timeCanvas.height;
            ctx.fillStyle = '#222';
            ctx.fillRect(0, 0, width, height);
            ctx.lineWidth = 2;
            ctx.strokeStyle = '#0f0';
            ctx.beginPath();
            const sliceWidth = width / bufferLength;
            let x = 0;
            for (let i = 0; i < bufferLength; i++) {
                const v = timeData[i] / 128.0;
                const y = (v * height) / 2;
                if (i === 0) {
                    ctx.moveTo(x, y);
                } else {
                    ctx.lineTo(x, y);
                }
                x += sliceWidth;
            }
            ctx.lineTo(width, height / 2);
            ctx.stroke();
        }
    }
}

export function drawFrequencyCanvas(
    freqCanvas: HTMLCanvasElement | null,
    freqData: Uint8Array,
    bufferLength: number
) {
    if (freqCanvas) {
        const ctx = freqCanvas.getContext('2d');
        if (ctx) {
            const width = freqCanvas.width;
            const height = freqCanvas.height;
            ctx.fillStyle = '#222';
            ctx.fillRect(0, 0, width, height);

            // Define the number of bars to display
            const numberOfBars = width * 2;
            const logMax = Math.log(bufferLength);

            for (let j = 0; j < numberOfBars; j++) {
                // Determine the frequency bin range for this bar on a logarithmic scale.
                const startBin = Math.floor(Math.exp((j / numberOfBars) * logMax));
                const endBin = Math.floor(Math.exp(((j + 1) / numberOfBars) * logMax));
                let sum = 0;
                let count = 0;
                // Average the amplitude values within the logarithmic bin range.
                for (let i = startBin; i < endBin; i++) {
                    sum += freqData[i];
                    count++;
                }
                const average = count ? sum / count : 0;
                const barHeight = (average / 255) * height;
                const barWidth = width / numberOfBars;
                const x = j * barWidth;
                ctx.fillStyle = `rgb(${barHeight + 100},50,50)`;
                ctx.fillRect(x, height - barHeight, barWidth, barHeight);
            }
        }
    }
}